import ordersService from '../../services/ordersService'

class OrdersController {
  searchOrders = ordersService.searchOrders
  createOrder = ordersService.createOrder
  fetchOrders = ordersService.fetchOrders
  updateOrder = ordersService.updateOrder
  fetchOrdersByCustomer = ordersService.fetchOrdersByCustomer
  reassignOrder = ordersService.reassignOrder
  fetchOrder = ordersService.fetchOrder
  editOrder = ordersService.editOrder
  exchangeOrder = ordersService.exchangeOrder
  refundOrder = ordersService.refundOrder
  cancelOrder = ordersService.cancelOrder
  fetchOrderConfig = ordersService.fetchOrderConfig
  updateOrderStatus = ordersService.updateOrderStatus
  payByEmail = ordersService.payByEmail
}

export default new OrdersController()



// WEBPACK FOOTER //
// ../src/controllers/ordersController/ordersController.js